module.exports = __webpack_public_path__ + "media/images/usc_logo-b3e4c34f634da89b82cc62d49b6ce0c8.svg";